module.exports = __webpack_public_path__ + "img/2-on.7d53436c.png";